<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
  <h6 [translate]="message"></h6>
  <mat-spinner diameter="64"></mat-spinner>
</div>
